import { nowUTC } from "@homebound/activesupport";
import { Banner, Button, Css } from "@homebound/beam";
import { useState } from "react";
import { pluralize } from "src/utils";
import { useReloadCostsBannerQuery } from "./ReloadCostsBanner.generated";

type ReloadCostsBannerProps = { productOfferingIds: string[]; onReload: () => Promise<unknown> | void };

/** Polls for configurations modified after the costs were loaded, and asks to reload when any exist. */
export function ReloadCostsBanner(props: ReloadCostsBannerProps) {
  const { productOfferingIds, onReload } = props;
  const [loadedAt, setLoadedAt] = useState(nowUTC);
  const query = useReloadCostsBannerQuery({
    variables: { filter: { productOfferings: productOfferingIds, afterUpdatedAt: loadedAt } },
    // Refresh every 15 seconds
    pollInterval: 15_000,
    fetchPolicy: "no-cache",
    skip: productOfferingIds.isEmpty,
  });
  const updatedConfigurations = query.data?.costConfigurationSummaries.entities.length ?? 0;

  if (updatedConfigurations === 0) {
    return null;
  }

  // TODO: update this banner with banner layout DS-368
  return (
    <div css={Css.mb2.$}>
      <Banner
        type="info"
        message={
          <div css={Css.df.gap1.$}>
            <div css={Css.fw6.$}>Updated Costs Ready</div>
            <div>
              Updated calculations are ready for {updatedConfigurations}{" "}
              {pluralize(updatedConfigurations, "configuration")}.
            </div>
            <Button
              label="Reload"
              variant="text"
              onClick={async () => {
                setLoadedAt(nowUTC());
                await onReload();
              }}
            />
          </div>
        }
      />
    </div>
  );
}
